<template>
    <div v-if="bookdetail">
    <div class="nav">
              <ul class="list3">
                  <li><el-button size="large" color="#e8f2ff"  tag="a" href="/"><el-icon><House /></el-icon>首页</el-button></li>
                  <li><el-button size="large" color="#e8f2ff" tag="a" href="/gkzl"><el-icon><Coin /></el-icon>高考资料</el-button></li>
                  <li><el-button size="large" color="#e8f2ff" tag="a" href="/zkjc"><el-icon><Reading /></el-icon>自考教材</el-button></li>
                  <li><el-button size="large" color="#e8f2ff"  tag="a" href="/sfjc"><el-icon><EditPen /></el-icon>书法教材</el-button></li>
                  <li><el-button size="large" color="#e8f2ff" tag="a" href="/bkzz"><el-icon><DocumentCopy /></el-icon>报刊杂志</el-button></li>
                  <li><el-button size="large" color="#e8f2ff" tag="a" href="/tjts"><el-icon><CollectionTag /></el-icon>特价图书</el-button></li>
                  <li><el-button size="large" type="primary" color="#5cbaf6" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/cjzs"><el-icon style="color: #ffffff;"><Notebook /></el-icon>成绩证书</el-button></li>
                  <li><el-button size="large" color="#e8f2ff" tag="a" href="/others"><el-icon><Menu /></el-icon>其他</el-button></li>
              </ul>
          </div>
          <div class="Breadcrumb">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item>成绩证书</el-breadcrumb-item>
                <el-breadcrumb-item>详情</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div>
            <div class="img">
                <el-carousel v-if="bookdetail.IMG_COVER && bookdetail.IMG_COVER.length" motion-blur height="500px">
                    <el-carousel-item v-for="(item, idx) in bookdetail.IMG_COVER" :key="idx">
                        <el-image :src="item" style="width: 320px; height: 440px; margin-top: 30px; object-fit: contain;" />
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="detail">
                <p class="bookname">{{ bookdetail.NAME }}</p>
                <p v-if="bookdetail.INTRODUCTION" class="bookintroduction">{{ bookdetail.INTRODUCTION }}</p>
                <p class="price">价格：<span>￥</span><span>{{ bookdetail.PRICE }}</span></p>
                <div class="buy-row">
                    <el-link :underline="false" :href="'/bookcode/'+id"><el-button size="large" color="#c93639">立即购买</el-button></el-link>
                    <el-image v-if="bookdetail.QR_CODE" class="qrcode-side" :src="bookdetail.QR_CODE" fit="contain" />
                </div>
            </div>
          </div>
          <div class="tags">
            <div style="width: 7px;height: 7px;background-color: orange;"></div>
            <div style="width: 7px;height: 33px;background-color:#49aef1 ; margin-top: 6px;"></div>
            <div class="tag1">详情参数</div>
            <div class="triangle"></div>
            <div class="tag"></div>
            <div class="more">MORE+</div>
            <hr>
           </div>
           <div class="bookcatalog">
            <el-image v-if="bookdetail.IMG_COVER && bookdetail.IMG_COVER[0]" class="img1" :src="bookdetail.IMG_COVER[0]" fit="contain" />
            <ul class="details">
                <li><div>名&nbsp;&nbsp; 称</div> {{ bookdetail.NAME }}</li><hr>
                <li><div>规&nbsp;&nbsp; 格</div> {{ bookdetail.AUTHOR }}</li><hr>
                <li v-if="showSizePages(bookdetail.SIZE)"><div>成品尺寸</div> {{ bookdetail.SIZE }}</li><hr v-if="showSizePages(bookdetail.SIZE)">
                <li v-if="showSizePages(bookdetail.PAGES)"><div>展开尺寸</div> {{ bookdetail.PAGES }}</li><hr v-if="showSizePages(bookdetail.PAGES)">
                <li><div>定&nbsp;&nbsp; 价</div> {{ bookdetail.PRICE }} &nbsp;元</li><hr>
            </ul>
            <div class="title">图文详情</div>
            <el-image v-for="(item, idx) in bookdetail.IMG_DIRECTORY" :key="idx" :src="item" class="img2" fit="cover" />
           </div>
        </div>
</template>

<script>
import { resolveFileUrl } from '@/utils/resolveFileUrl'

export default {
    name: "CJZSDetail",
    props: {
        id: String
    },
    data() {
        return {
            bookdetail: null
        }
    },
    methods: {
        showSizePages(val) {
            if (val === null || val === undefined || val === '' || val === 0 || val === '0') {
                return false
            }
            return true
        },
        getBookDetail() {
            this.$axios.post('/api/Book/BookDetail', {
                ID: this.id
            }).then(res => {
                const d = res.data
                const splitList = (raw) => {
                    if (raw == null || raw === '') return []
                    return String(raw)
                        .split(/[,，;；]/) /* 半角/全角逗号与分号 */
                        .map(s => s.trim())
                        .filter(Boolean)
                        .map(resolveFileUrl)
                }
                d.IMG_COVER = splitList(d.IMG_COVER)
                d.IMG_DIRECTORY = splitList(d.IMG_DIRECTORY)
                if (d.QR_CODE) d.QR_CODE = resolveFileUrl(d.QR_CODE)
                this.bookdetail = d
            })
        }
    },
    created() {
        this.getBookDetail()
    },
    watch: {
        id() {
            this.getBookDetail()
        }
    }
}
</script>

<style scoped>
.buy-row{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 24px;
    margin-top: 40px;
}
.qrcode-side{
    width: 120px;
    height: 120px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
}
.img2{
    width: 890px;
    height: 100%;
    margin-top: 50px;
    display: block;
    margin-left: 200px;
    float: left;
}
.title{
    width: 890px;
    height: 100px;
    background-color: #c00202;
    float: left;
    margin-left: 200px;
    margin-top: 80px;
    border-radius: 90px;
    color: #ffffff;
    font-size: 70px;
}
.details hr{
    display: inline-block;
    width: 420px;
    margin-left: 0px;
    border: none;
    height: 1px;
    background: #000;
}
.details li div{
    display: inline-block;
    width: 90px;
    text-align: center;
    margin-right: 20px;
    font-size: 22px;
    font-weight: 500;
    height: 32px;
    background-color: #c00202;
    color: #ffffff;
}
.details li{
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
    text-align: left;
    color: #010101;
}
.details{
    width: 420px;
    height: 500px;
    float: left;
    margin-top: 80px;
    margin-left: 50px;
    list-style-type: none;
}
.img1{
    width: 420px;
    height: 500px;
    margin-top: 80px;
    margin-left: 200px;
    float: left;
}
.bookcatalog{
    width: 1300px;
    border-radius: 6px;
    border: #f0efef solid 1px;
    float: left;
    margin-left: 250px;
    margin-top: 20px;
}
/* 弹窗 (background) */
.modal {
    display: none; /* 默认隐藏 */
    position: fixed; 
    z-index: 1; 
    padding-top: 400px; 
    left: 0;
    top: 0;
    width: 100%; 
    height: 100%; 
    overflow: auto; 
    background-color: rgb(0,0,0); 
    background-color: rgba(0,0,0,0.4);
}

/* 弹窗内容 */
.modal-content {
    position: relative;
    background-color: #fefefe;
    margin: auto;
    padding: 0;
    border-radius: 8px;
    border: 1px solid #888;
    width: 250px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
    -webkit-animation-name: animatetop;
    -webkit-animation-duration: 0.4s;
    animation-name: animatetop;
    animation-duration: 0.4s
}

/* 添加动画 */
@-webkit-keyframes animatetop {
    from {top:-300px; opacity:0} 
    to {top:0; opacity:1}
}

@keyframes animatetop {
    from {top:-300px; opacity:0}
    to {top:0; opacity:1}
}

/* 关闭按钮 */
.close .el-icon {
    color: #ffffff;
    font-weight: bold;
    margin-top: 20px;
    margin-left: 90px;
}

.close:hover,
.close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
}

.modal-header {
    padding-top: 10px;
    height: 50px;
    background: linear-gradient(to top, #48a9f3,#6bc8f9);
    color: white;
    border-radius: 8px 8px 0 0;
}

.modal-body {padding: 2px 16px;}

.modal-footer {
    padding: 2px 16px;
    float: left;
    color: white;
}
.argument span:nth-child(3){
    position: absolute;
}
.argument span:nth-child(2){
    position: absolute;
    margin-left: -350px;
}
.argument span{
    font-size: 16px;
    font-weight: bold;
    margin-left: 20px;
    margin-top: 20px;
    color: #515c68;
    float: left;
}
.argument{
    width: 1300px;
    border-radius: 6px;
    height: 60px;
    margin-left: 250px;
    margin-top: 20px;
    background: linear-gradient(to bottom, #fafafa,#f6f7f7);
    border: #f0efef solid 1px;
    float: left;
}
.more{
    float: right;
    margin-right: 300px;
    margin-top: -29px;
    color: #79838a;
}
hr{
    width: 1160px;
    margin-left: 140px;
    margin-top: -2px;
    border: 1px solid #efefef;
}
.tags{
    width: 1600px;
    float: left;
    height: 46px;
    margin-left: 250px;
    margin-top: 10px;
}
.tag1{
    font-size: 20px;
    color: #ffffff;
    width: 110px;
    height: 46px;
    margin-top: -46px;
    margin-left: 15px;
    position: relative;
    padding-top: 10px;
    background: linear-gradient(to top, #47a8f3,#6ac7f8);
}
.triangle{
    width: 25px;
    height: 46px;                                       
    margin-left: 125px;
    clip-path: polygon(0 0, 0 100%, 50% 100%);
    margin-top: -46px;
    background: linear-gradient(to top, #47a8f3,#6ac7f8)
}
.tag{
    width: 800px;
    float: left;
    height: 26px;
    margin-left: 138px;
    background-color: #efefef;
    margin-top: -35px;
    background: repeating-linear-gradient(145deg, white, white 2px, #efefef 2px, #efefef 4px) ;
    mask-image: linear-gradient(to left, transparent 0%, black 60%);
    transform: skew(19deg);
}
.detail .el-button{
    color: #ffffff;
    margin-top: 0;
    width: 150px;
    height: 50px;
    font-size: 17px;
    border-radius: 7px;
}

.price span:nth-child(2){
    font-size: 30px;
    font-weight: bold;
    color: #d41e26;
}
.price span:nth-child(1){
    font-size: 17px;
    font-weight: bold;
    color: #d41e26;
}
.price{
    font-size: 17px;
    margin-top: 80px;
    font-weight: 550;
    color: #7d878e;
}
.code{
    font-size: 17px;
    margin-top: 60px;
    font-weight: 550;
    color: #000000;
}
.bookintroduction{
    font-size: 15px;
    margin-top: 60px;
    line-height: 30px;
    font-weight: 550;
    color: #8d959b;
}
.bookname{
    font-size: 20px;
    margin-top: 10px;
    font-weight: bold;
    color: #4f5b66;
}
.detail{
    width: 800px;
    height: 500px;
    margin-top: 25px;
    margin-left: 60px;
    text-align: left;
    float: left;
}
.img{
    width: 420px;
    height: 500px;
    margin-top: 30px;
    margin-left: 250px;
    border: #c3d1db solid 1px;
    float: left;
}
.el-breadcrumb{
    margin-top: 20px;
    margin-left: 270px;
    height: 60px;
    font-size: 16px;
    color: #c1c6c9;
    float: left;
}
.Breadcrumb{
    width: 1903px;
    height: 60px;
    background: #f5f6f6;
    margin-top: 10px;
    margin-left: -20px;
    float: left;
}
  .el-icon{
      font-size: 25px;
      margin-right: 10px;
      color: #49aef1;
  }
  
  .list3 .el-button{
      width: 161px;
      height: 46px;
      font-size: 16px;
      border-radius: 7px;
      color: #000;
      margin-top: 1px;
      padding-left: 10px;
      background: linear-gradient(to top, #deedff,#f3f8ff);
  }
  .list3 {
      list-style-type: none;
      float: left;
      margin-left: 240px;
      margin-top: 5px;
      height: 60px;
  }
  
  .list3 li {
      float: left;
      font-size: 20px;
      margin-left: 20px;
      width: 165px;
      height: 50px;
      font-weight: bold;
      border-radius: 7px;
      display: block;
      color: #49aef1;
      border: #c3d1db solid 1px;
  }
  .list3 a{
      text-decoration: none;
      color: #49aef1;
  }
 .nav .el-button:hover {
      background: linear-gradient(to top, #47a8f3,#6ac7f8);
      color: #ffffff;
  }
  
 .nav .el-button:hover .el-icon {
      color: #ffffff;
  }
</style>

